import { dramaCategories } from "@/mocks/dramas";

type SiteFooterProps = {
  onPickCategory: (category: string) => void;
};

const sectionLinks = [
  { href: "#new", label: "最新更新" },
  { href: "#catalog", label: "短剧合集" },
  { href: "#featured", label: "精选解读" },
  { href: "#characters", label: "人物档案" },
  { href: "#guide", label: "观看指南" },
  { href: "#faq", label: "常见问答" },
  { href: "#topics", label: "题材热词" },
];

export default function SiteFooter({ onPickCategory }: SiteFooterProps) {
  const cats = dramaCategories.filter((c) => c !== "全部");

  return (
    <footer className="w-full bg-primary-800 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-900">
                <i className="ri-movie-2-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">女友的妈妈</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-100">
              岳母题材真人剧情演绎短片与短剧合集，按题材分区浏览，每日更新。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">页面分区</h3>
            <ul className="mt-4 space-y-2.5">
              {sectionLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="cursor-pointer text-sm text-primary-100 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">按题材浏览</h3>
            <ul className="mt-4 space-y-2.5">
              {cats.map((cat) => (
                <li key={cat}>
                  <a
                    href="#catalog"
                    onClick={() => onPickCategory(cat)}
                    className="cursor-pointer text-sm text-primary-100 transition-colors hover:text-accent-300"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">内容声明</h3>
            <p className="mt-4 text-sm leading-relaxed text-primary-100">
              站内所有短剧均为真人剧情演绎，人物、情节与对白均为虚构创作，不对应现实中的具体个人或事件。
              请理性看待剧情设定，区分演绎内容与现实生活。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-700 pt-6 text-xs text-primary-200 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 女友的妈妈短剧合集 · 内容仅供剧情演绎与娱乐观看</p>
          <p className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <span>本站为演示性质的内容展示页面</span>
            <span className="hidden sm:inline">·</span>
            <span>不提供真实账号与提交功能</span>
          </p>
        </div>
      </div>
    </footer>
  );
}